import React, { useEffect, useState } from 'react'
import './main-themes.scss'
import { useSelector } from 'react-redux'
import { fetchTopicsModal } from '../../redux/actions/topics-modal.actions'
import { LoadingOutlined } from '@ant-design/icons'
import { getSummarySourceThemes, getThread } from '../../redux/selectors'
import { fetchCurrentSmiParams } from '../../redux/actions'
import { useAppDispatch } from '../../redux/store/hooks'
import { summaryService } from '../../api'
import { topicMapper } from '../../api/usecases/summary/utils/topic-mapper'
import { Modal } from 'antd'
import { showChangePostTonalModal } from '../../redux/actions/change-post-tonal.actions'
import Post from '../post'



type Props = {
  updateTopic?: any;
}

const MainThemes: React.FC<Props> = ({ updateTopic }: Props) => {
  const topics = useSelector(getSummarySourceThemes)
  //const [topics, setTopics] = useState<any>([])
  const [isLoading, setIsLoading] = useState(false)
  const thread = useSelector(getThread);
  const dispatch = useAppDispatch()
  const [mainTopic, setMainTopic] = useState<any>()
  const [topicsModalIsOpen, setTopicsModalIsOpen] = useState<any>(false)
  const [topicsModalIsLoading, setTopicsModalIsLoading] = useState(false)
  const [topicsModalPosts, setTopicsModalPosts] = useState<any>()
  const [mentioningSelected, setMentioningSelected] = useState(false)
  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')
  const [period, setPeriod] = useState((): 'yesterday' | 'day' | 'week' | 'month' => 'day')
  const [tonal, setTonal] = useState<number>()

  useEffect(() => {
    console.log("tttt", topics)
    dispatch(fetchCurrentSmiParams(topics?.group_id))
    //dispatch(setTopicsModalIsOpen(true))
    //updatePostList()
  }, [])

  useEffect(() => {
    updateTopic([])

  }, [topics])

  const loadModalPosts = (item: any) => {
    setTopicsModalIsLoading(true)
    summaryService.loadTopic(item.group_id, "all")
      .then((resp: any) => {
        console.log('222', resp)
        setTopicsModalPosts(resp)
        setTopicsModalIsLoading(false)
      })
      .catch(() => {
        console.log('FAIL1111')
      })
  }

  const showTopics = (item: any): void => {
    //dispatch(fetchTopicsModal(item, [from, to], from, to, period))
    //updateTopic(item)

    setTopicsModalIsOpen(true)
    setMainTopic(item)
    loadModalPosts(item)
  }

  const hideTopics = (e: any): void => {
    setTopicsModalIsOpen(false)
    setMentioningSelected(false)
  }

  const updateData = (value: any) => {
    if (value === 1 || value === -1) setTonal(value)
    else changeTonal(value)
  }

  const changeTonal = (post: any): void => {
    dispatch(showChangePostTonalModal({ post, list: topicsModalPosts }))
  }

  return (
    <div className="summary-topics-week">
      <div className="topics-list summary-topics-week__list">
        {isLoading
          ? (
            <div className="feed-posts-loader">
              <LoadingOutlined />
            </div>
          )
          : topics?.list?.length > 0
            ? topics?.list?.slice(0,5).map((item: any, index: number) => {
              //console.log(item)
              const data = {
                // labels: item.total_graph ? [...item.total_graph].map(it => it[0]) : [],
                datasets: [
                  {
                    fill: false,
                    tension: 0,
                    backgroundColor: '#4FD1C5',
                    borderColor: '#4FD1C5',
                    borderWidth: 1.5,
                    data: item.total_graph ? [...item.total_graph].map(it => ({ x: it.item_date, y: it.post_count })) : []
                  }
                ]
              }
              const options = {
                plugins: {
                  legend: {
                    display: false
                  }
                },
                elements: {
                  point: {
                    pointStyle: 'dash',
                    radius: 1,
                    borderWidth: 0,
                    hoverRadius: 2
                  }
                },
                scales: {
                  x: {
                    display: false,
                    grid: {
                      color: '#111',
                      borderColor: '#111',
                      lineWidth: 0.5
                    }
                  },
                  y: {
                    beginAtZero: true,
                    grid: {
                      color: '#111',
                      borderColor: '#111',
                      lineWidth: 0.5
                    },
                    ticks: {
                      stepSize: 1
                    }
                  }
                }
              }
              return (
                <div className="topics-list-row" key={index}>
                  <div className="topics-list-row__wrap">
                    <div className="topics-list-row__rating">{String(index + 1)}</div>
                    <div className="topics-list-row__theme">
                      <div>
                        <div
                          className="topics-list-row__text"
                          onClick={() => showTopics(item)}
                        >{item.title}</div>
                      </div>
                      <div className="statistic-list-row-info">
                        {/*<p className="statistic-list-row__label">Количество публикаций:</p> 
                            <div> 
                              <span className="statistic-list-row-info__value">{item.storyDocs}</span>
                              {item.lastHourDocs > 0 ? <sup className="up">+{item.lastHourDocs}</sup> : null}
              </div>*/}
                        {<><p className="statistic-list-row__label">Общее количество публикаций:</p>
                          <div>
                            <span className="statistic-list-row-info__value">{item.storyDocs}</span>{item.lastHourDocs > 0 ? <sup className="up">+{item.lastHourDocs}</sup> : null}
                          </div></>}
                      </div>
                      {/*<div className="topics-list-row-info topics-list-row-info--fw">
                        <p className="topics-list-row__label">Публикаций с упоминанием субъекта: <span className="topics-list-row-info__value">{item.postcount}</span>   Охват: <span className="topics-list-row-info__value">{item.attendance.toLocaleString('ru-RU')}</span></p>
                        {topicsType !== 'social'
                          ? <p className="topics-list-row__label">Всего публикаций в теме: <span className="topics-list-row-info__value">{item.total_posts}</span>   Охват: <span className="topics-list-row-info__value">{item.total_attendance.toLocaleString('ru-RU')}</span></p>
                          : null
                        }
                      </div>*/}
                    </div>
                  </div>
                </div>
              )
            })
            : <div className="topics-list__empty">Сформированных тем пока нет</div>
        }
      </div>
      <Modal
        open={topicsModalIsOpen}
        width="80%"
        onCancel={hideTopics}
        footer={null}
        className="topics-modal-parent"
      >
        <div className="topics-modal">
          <div className="topics-modal__wrap">
            {topicsModalIsLoading ? (
              <div className="topics-modal__loading">
                <div className="feed-posts-loader">
                  <LoadingOutlined />
                </div>
              </div>
            ) : topicsModalPosts?.length > 0 ? (
              <>
                <div className="topics-modal__header">
                  <h2>
                    <span className="topics-list-row-info__value">Тема:</span>
                    {mainTopic?.title}
                  </h2>
                  <div className="topics-modal__info">
                    <p className="topics-list-row__label">
                      Публикаций с упоминанием {'субъекта'}:{' '}
                      <span className="topics-list-row-info__value">
                        {' '}
                        {mainTopic?.postcount}
                      </span>
                      , охват:{' '}
                      <span className="topics-list-row-info__value">
                        {' '}
                        {mainTopic?.attendance?.toLocaleString('ru-RU')}
                      </span>
                    </p>
                    <p className="topics-list-row__label">
                      Всего публикаций в теме:{' '}
                      <span className="topics-list-row-info__value">
                        {' '}
                        {mainTopic?.total_posts}
                      </span>
                      , охват:{' '}
                      <span className="topics-list-row-info__value">
                        {' '}
                        {mainTopic?.total_attendance?.toLocaleString('ru-RU')}
                      </span>
                    </p>
                    <p className="topics-list-row__label">
                      Количество информационных источников:{' '}
                      <span className="topics-list-row-info__value">
                        {' '}
                        {
                          topicsModalPosts?.map((it: any) => it.author.url)
                            .length
                        }
                      </span>
                    </p>
                    <p className="topics-list-row__label">
                      Соотношение тональности публикаций: нейтральных -{' '}
                      <span className="topics-list-row-info__value">
                        {
                          topicsModalPosts?.filter(
                            (it: any) => it.trust !== 1 && it.trust !== -1,
                          ).length
                        }
                      </span>
                      , позитивных -{' '}
                      <span className="topics-list-row-info__value">
                        {
                          topicsModalPosts?.filter((it: any) => it.trust === 1)
                            .length
                        }
                      </span>
                      , негативных -{' '}
                      <span className="topics-list-row-info__value">
                        {
                          topicsModalPosts?.filter((it: any) => it.trust === -1)
                            .length
                        }
                      </span>
                    </p>
                    <div
                      className="topics-modal__mentioning"
                      onClick={() =>
                        setMentioningSelected((prevState: any) => !prevState)
                      }
                    >
                      <div
                        className={`checkbox${mentioningSelected ? ' active' : ''
                          }`}
                      />
                      <span>Показать с упоминанием</span>
                    </div>
                  </div>
                </div>
                {topicsModalIsLoading ? (
                  <div className="topics-modal__loading">
                    <div className="feed-posts-loader">
                      <LoadingOutlined />
                    </div>
                  </div>
                ) : (
                  <div className="topics-modal__list">
                    {topicsModalPosts?.map((item: any) => (
                      <Post
                        key={item.id}
                        post={item}
                        type="topic"
                        changeTonal={updateData}
                      />
                    ))}
                  </div>
                )}
              </>
            ) : (
              <div className="topics-modal__empty">Постов пока нет</div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default MainThemes
